import React, { Component } from 'react'
import InlineSvg from 'svg-inline-react'

import Button from 'shared-web/src/components/Button'
import CheckBox from 'shared-web/src/components/CheckBox'
import Input from 'shared-web/src/components/Input'

import { HeaderBody as HeaderBodyClass } from './HeaderBody.styl'
import ModalHeader from 'components/customer/EndUserAttributesCard/AttributesModal/ModalHeader'
import GetRows from 'components/customer/EndUserAttributesCard/helper'
import CancelAndSave from 'components/customer/CompanyCard/CancelAndSave'
import Modal from 'components/shared/Modal'
import Category from 'components/customer/EndUserAttributesCard/AttributesModal/Category'

const Icon = (
  <InlineSvg
    src={require('!svg-inline?removeTags=true!images/svg/rolodex2-gray.svg')}
    style={{ width: 25, height: 17, marginRight: 12 }}
    element="div"
  />
)

class AttributesModal extends Component {
  state = {
    search: '',
    hideBlank: false,
  }

  onSearchChange = (search) => {
    this.setState({ search })
  }

  onCheckBoxSelection = () => {
    this.setState({ hideBlank: !this.state.hideBlank })
  }

  filterRows(rows) {
    const { enabledAttributes, createAttributeCheckBoxChange } = this.props
    const { hideBlank, search } = this.state
    return rows
      .filter(({ empty, value }) => {
        if (hideBlank && typeof empty === 'undefined') {
          return typeof value !== 'undefined' && value !== null
        }
        if (hideBlank) return !empty
        return true
      })
      .filter(({ label }) => !search || (label && label.indexOf(search) !== -1))
      .map(({ label, ...rest }) => ({
        label,
        checked: enabledAttributes.has(label),
        handleCheckBoxChange: createAttributeCheckBoxChange(label),
        ...rest,
      }))
  }

  render() {
    const {
      onClose,
      contactRows,
      socialRows,
      driftRows,
      customRows,
      changed,
      handleCancel,
      handleSave,
      handleEdit,
      editing,
      updating,
    } = this.props
    const { search, hideBlank } = this.state

    const filteredContactRows = this.filterRows(contactRows)
    const filteredSocialRows = this.filterRows(socialRows)
    const filteredDriftRows = this.filterRows(driftRows)
    const filteredCustomRows = this.filterRows(customRows)

    return (
      <Modal
        onRequestClose={onClose}
        isOpen={true}
        style={{
          content: {
            padding: 0,
            width: 550,
            maxHeight: '90%',
            overflowY: 'auto',
          }
        }}
      >
        <ModalHeader onClose={onClose}>
          <div className={`dsg-Title flex ${HeaderBodyClass}`}>
            {Icon}
            All Attributes
          </div>
        </ModalHeader>
        <div style={{ padding: 27 }}>
          <Input
            placeholder="Search"
            isValid={true}
            valueLink={{
              requestChange: this.onSearchChange,
              value: search,
            }}
            size="medium"
          />
          <div className="flex-space-between" style={{ padding: '5px 0 15px 0' }}>
            <div className="flex">
              <CheckBox
                id="hideBlank"
                checked={hideBlank}
                onChange={this.onCheckBoxSelection}
              />
              <span
                className="dsg-Body color-navy-dark"
                style={{ paddingLeft: 5 }}
              >
                Hide Blank Properties
              </span>
            </div>
            {
              editing
                ? <CancelAndSave
                    updating={updating}
                    changed={changed}
                    onCancel={handleCancel}
                    onSave={handleSave}
                  />
                : <div className="link edit dsg-Body" onClick={handleEdit}>
                    Edit
                  </div>
            }
          </div>
          {filteredContactRows.length
            ? <Category title="Contact Attributes" rows={filteredContactRows} editing={editing}/>
            : null}
          {filteredSocialRows.length
            ? <Category title="Social Attributes" rows={filteredSocialRows} editing={editing}/>
            : null}
          {filteredDriftRows.length
            ? <Category title="Drift Attributes" rows={filteredDriftRows} editing={editing}/>
            : null}
          {filteredCustomRows.size
            ? <Category title="Custom Attributes" rows={filteredCustomRows.toList()} editing={editing}/>
            : null}
          { !editing &&
              <Button
                className="flex-center"
                cta={true}
                style={{ width: '100%' }}
                onClick={onClose}
              >
                done
              </Button>
          }
        </div>
      </Modal>
    )
  }
}

export default GetRows(AttributesModal)



// WEBPACK FOOTER //
// ./src/scripts/components/customer/EndUserAttributesCard/AttributesModal/index.js